import { Schedule } from "./hours.types";

export const Time = {
    PM: 'pm',
    AM: 'am'
};

export const WeekDays = [
    {key:'sunday', date: 'Sunday,', weekly: 'Sundays', schedule: 'SU'},
    {key:'monday', date: 'Monday,', weekly: 'Mondays', schedule: 'MO'},
    {key:'tuesday', date: 'Tuesday,', weekly:  'Tuesdays', schedule: 'TU'},
    {key:'wednesday', date: 'Wednesday,', weekly: 'Wednesdays', schedule: 'WE'},
    {key:'thursday', date: 'Thursday,', weekly: 'Thursdays', schedule: 'TH'},
    {key:'friday', date: 'Friday,', weekly: 'Fridays', schedule: 'FR'},
    {key: 'saturday', date: 'Saturday,', weekly: 'Saturdays', schedule: 'SA'}
]

export const ParkHourStatus = {
    OPEN: 'Open',
    CLOSED: 'Closed'
}

export const CloseStatus: Schedule = {
    scheduleKey: 'CLOSED',
    recurrence: "FREQ=DAILY;INTERVAL=1",
    priority: 1,
    instances: [{
        startTime: "2023-10-20T00:00:00",
        endTime: "2023-10-20T23:59:59"
    }]
}
